__turbopack_context__.v({
  "activePickerSwatch": "ColorInput-module__8eLO4G__activePickerSwatch",
  "activeSwatch": "ColorInput-module__8eLO4G__activeSwatch",
  "dropdown": "ColorInput-module__8eLO4G__dropdown",
  "errorSwatch": "ColorInput-module__8eLO4G__errorSwatch",
  "inactiveSwatch": "ColorInput-module__8eLO4G__inactiveSwatch",
  "input": "ColorInput-module__8eLO4G__input",
  "label": "ColorInput-module__8eLO4G__label",
  "picker": "ColorInput-module__8eLO4G__picker",
  "pickerSwatches": "ColorInput-module__8eLO4G__pickerSwatches",
  "popover": "ColorInput-module__8eLO4G__popover",
  "swatch": "ColorInput-module__8eLO4G__swatch",
  "swatchInner": "ColorInput-module__8eLO4G__swatchInner",
});
